import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit,
    OnDestroy
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {AppLoadingEventsEmitter} from '../../../../shared/events/loading.events';
import {MasterProductViewModel, MasterRecipeViewModel} from '../../../../shared/viewModels/diarySummary.viewModel';

@Component({
    selector: 'app-view-recipe-statistics',
    templateUrl: './view-recipe-statistics.component.html',
    styleUrls: ['./view-recipe-statistics.component.scss']
})
export class ViewRecipeStatisticsComponent implements OnInit, AfterViewInit, OnDestroy {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    bsModaRefStatistics: BsModalRef;
    subscriptions: Subscription[] = [];

    recipe: MasterRecipeViewModel = null;
    showCookedWeight = true;

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
    ) {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    ngOnInit() {
        this.subscriptions.push(
            this.bsModalEventsEmitter.bsModalStateChanged$.pipe(filter(bsModalRef => bsModalRef === this.bsModalRef)).subscribe(() => {
                this.init();
            })
        );
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    roundNumber(number: number) {
        return Math.round(number);
    }

    public init() {
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    sortedProducts(products: MasterProductViewModel[]) {
        return products.sort((a, b) => {
            return b.weight - a.weight;
        });
    }
}
